'use strict';

module.exports.svt1 = {
	name: 'SVT1',
	broadcast: true
};

module.exports.svt2 = {
	name: 'SVT2',
	broadcast: true
};

module.exports.svtb = {
	name: 'Barnkanalen',
	broadcast: true
};

module.exports.svt24 = {
	name: 'SVT24',
	broadcast: true
};

module.exports.svtweb = {
	name: 'SVT Play',
	broadcast: false
};



/** WEBPACK FOOTER **
 ** ./app/utils/channels.js
 **/